import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4e29e376&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=4e29e376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29e376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e29e376')) {
      api.createRecord('4e29e376', component.options)
    } else {
      api.reload('4e29e376', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=4e29e376&scoped=true&", function () {
      api.rerender('4e29e376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Dashboard.vue"
export default component.exports